/**
 * Trạng thái sắp xếp
 */
export default {
  /**
   * Giảm dần
   */
  desc: 1,
  /**
   * Tăng dần
   */
  asc: 2
};
